const  UserModel = {
    token: null,
    user: null
}
export default UserModel